Octopus.Model = Octopus.Model || {};

Octopus.Model.SynchronizedList = function (options) {
    var defaults = {
        sourceToTargetTransformer: function (a) {
            return a;
        },
        refresh: function(b, a) {
    },
        sourceKey: function (a) {
            return a.Id;
        },
        onAdded: function(a) { },
        onRemoved: function(a) { }
    };

    options = jQuery.extend(defaults, options);

    var self = this;
    self.items = [];
    self.itemsMap = { };

    self.sync = function(source) {

        var seenSourceItems = {};

        if (!source) {
            return;
        }

        jQuery.each(source, function (ignore, src) {
            if (!src) {
                return;
            }

            var srcKey = options.sourceKey(src);
            if (!srcKey) {
                return;
            }

            if (!self.itemsMap[srcKey]) {
                var newTarget = options.sourceToTargetTransformer(src);
                self.itemsMap[srcKey] = newTarget;
                self.items.push(newTarget);

                options.onAdded(newTarget);
            } else {
                var target = self.itemsMap[srcKey];
                options.refresh(target, src);
            }

            seenSourceItems[srcKey] = true;
        });

        var removedKeys = [];
        var removedValues = [];

        jQuery.each (self.itemsMap, function (srcKey, val) {
            if (!seenSourceItems[srcKey]) {
                removedKeys.push(srcKey);
                removedValues.push(val);
            }
        });

        jQuery.each (removedKeys, function (ignore, k) {
            delete self.itemsMap[k];
        });

        jQuery.each (removedValues, function (ignore, k) {
            var ix = self.items.indexOf(k);
            if (ix >= 0) {
                self.items.splice(ix, 1);
                options.onRemoved(k);
            }
        });

        if (options.sortTargetBy) {
            self.items.sort(function(first, second) {
                var f = options.sortTargetBy(first);
                var s = options.sortTargetBy(second);
                if (f === s) { return 0; }
                if (f < s) { return -1; }
                return 1;
            });
        }
    };
};




//////////////////
// WEBPACK FOOTER
// ./app/model/synchronized_list.js
// module id = 714
// module chunks = 1